import axios from "axios";
import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";

import FormInput from "../component/FormInput";
import FormMultiSelect from "../component/FormMultiSelect";
import FormSelect from "../component/FormSelect";
import { getToken } from "./authentication";
import { subjectsList } from "./subjectsList";
import { SCHOOL_STEP, SCHOOL_TYPE } from "./swiss_schools";

export default function EditModal({
  editDialog,
  setEditDialog,
  surveyruns_mutate,
}) {
  const [description, setDescription] = useState();
  const [date, setDate] = useState();
  const [schoolType, setSchoolType] = useState();
  const [schoolStep, setSchoolStep] = useState();
  const [subject, setSubject] = useState();

  useEffect(() => {
    setDescription(editDialog?.description);
    setDate(editDialog?.date);
    setSchoolType(editDialog?.school_type);
    setSchoolStep(editDialog?.school_step);
    setSubject(editDialog?.subject);
  }, [editDialog]);

  return (
    <Modal
      isOpen={!!editDialog}
      aria={{
        labelledby: "heading",
        describedby: "full_description",
      }}
      onRequestClose={() => setEditDialog(null)}
      className="Teaser"
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          zIndex: 10000,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: " translate(-50%, -50%)",
          maxHeight: "90vh",
          overflowX: "auto",
        },
      }}
    >
      <div className="Teaser--inner">
        <div className="Teaser--header"></div>
        <h3 className="Teaser--title">
          <span className="Link layout-standalone size-small">
            Bearbeiten: Umfrage im Fach {editDialog?.subject} vom{" "}
            {DateTime.fromISO(editDialog?.date).toLocaleString(
              DateTime.DATE_MED
            )}
          </span>
        </h3>
      </div>
      <div className="Teaser--body">
        <div className={`Teaser--text richtext`}>
          {editDialog?.done ? (
            <p>
              Die Anzahl Umfragen kann nur bei noch laufenden Umfragen geändert
              werden.
            </p>
          ) : (
            <p>
              Auf der{" "}
              <Link to={`/dashboard/teilnahmeliste/${editDialog?.id}`}>
                Seite der Zugangscodes
              </Link>{" "}
              können Sie Zugangscodes hinzufügen und/oder entfernen.
            </p>
          )}

          <FormInput
            label={
              "Bitte beschreiben Sie die Klasse, in der Sie eine Umfrage durchführen wollen. Die Beschreibung hilft Ihnen, die Klasse wieder zuordnen zu können (Beispiel: 6a)."
            }
            required
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <FormInput
            label="Bitte geben Sie das Datum der Umfrage an."
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />

          <FormSelect
            label="Bitte wählen Sie die Schulart aus."
            options={SCHOOL_TYPE.map((type) => ({
              value: type,
              text: type,
            }))}
            value={schoolType}
            onChange={(e) => setSchoolType(e.target.value)}
          />
          <FormMultiSelect
            label="Bitte wählen Sie die Klassenstufe(n) aus."
            options={SCHOOL_STEP.map((step) => ({
              value: step,
              text: step,
            }))}
            value={schoolStep}
            onChange={(value) => setSchoolStep(value)}
          />
          <FormSelect
            label="Bitte wählen Sie das Fach aus."
            options={subjectsList.map((subject) => ({
              value: subject,
              text: subject,
            }))}
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>
        <div
          className="FormButtons"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button
            className="Button size-large"
            onClick={() => setEditDialog(null)}
            autoFocus
          >
            Schliessen
          </button>
          <button
            className="Button color-primary size-large"
            onClick={async () => {
              await axios.patch(
                editDialog?.url,
                {
                  date,
                  subject,
                  description,
                  school_type: schoolType,
                  school_step: schoolStep,
                },
                {
                  headers: {
                    Authorization: `Token ${getToken()}`,
                  },
                }
              );
              await surveyruns_mutate();
              setEditDialog(null);
            }}
          >
            Speichern
          </button>
        </div>
      </div>
    </Modal>
  );
}
